/* ============================================================
   Ofertas y pagos SEPARADOS (tarjeta / contraentrega) — versión general
   Se carga solo en páginas de producto que lo incluyen (hoy: El Correlón).
   El botón de tarjeta lleva [data-fb-tarjeta] y define:
     data-variante, data-codigo-1/2/3,
     data-radios   = selector de los radios de paquete (ej. "[data-cr-paquete]")
     data-cantidad-attr = atributo con la cantidad ("value" o "data-cantidad")
     data-contraentrega="omitir" si la página ya tiene su propio control del botón de Releasit.
   1) Tarjeta: vacía el carrito y va a /cart/VARIANTE:CANTIDAD?discount=CÓDIGO_DEL_PAQUETE.
   2) Al volver de ese intento: vacía carrito + quita códigos + recarga una vez.
   3) Visita normal: no toca el carrito, solo quita códigos pegados.
   ============================================================ */
(function () {
  if (window.__ofertasPago) return;
  window.__ofertasPago = true;

  var JSON_H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var MARCA = 'fbVolviendoDeTarjeta';

  function boton() { return document.querySelector('[data-fb-tarjeta]'); }

  function leerCarrito() {
    return fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function quitarCodigos() {
    return leerCarrito().then(function (c) {
      if (c && c.discount_codes && c.discount_codes.length) {
        return fetch('/cart/update.js', { method: 'POST', headers: JSON_H, body: JSON.stringify({ discount: '' }) });
      }
    }).catch(function () {});
  }
  function vaciarCarrito() {
    return fetch('/cart/clear.js', { method: 'POST', headers: JSON_H }).catch(function () {}).then(quitarCodigos);
  }

  function volvioDeTarjeta() { try { return sessionStorage.getItem(MARCA) === '1'; } catch (e) { return false; } }
  function marcarTarjeta() { try { sessionStorage.setItem(MARCA, '1'); } catch (e) {} }
  function olvidarTarjeta() { try { sessionStorage.removeItem(MARCA); } catch (e) {} }

  function cantidadElegida(b) {
    var sel = b.getAttribute('data-radios') || '[data-mt-paquete-radio]';
    var attr = b.getAttribute('data-cantidad-attr') || 'data-cantidad';
    var r = document.querySelector(sel + ':checked');
    var n = parseInt(r ? r.getAttribute(attr) : '1', 10);
    return n >= 1 && n <= 3 ? n : 1;
  }

  /* ---------- Pago con tarjeta ---------- */
  function initTarjeta() {
    var b = boton();
    if (!b) return;
    var span = b.querySelector('[data-fb-tj-titulo]') || b.querySelector('span');
    var textoInicial = span ? span.innerHTML : b.innerHTML;
    var ocupado = false;
    function reactivar() { ocupado = false; b.disabled = false; if (span) span.innerHTML = textoInicial; }

    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (ocupado) return;
      ocupado = true;
      b.disabled = true;
      if (span) span.textContent = b.getAttribute('data-texto-cargando') || 'Un momento…';
      var n = cantidadElegida(b);
      var codigo = (b.getAttribute('data-codigo-' + n) || '').trim();
      var url = '/cart/' + b.getAttribute('data-variante') + ':' + n + (codigo ? '?discount=' + encodeURIComponent(codigo) : '');
      marcarTarjeta();
      fetch('/cart/clear.js', { method: 'POST', headers: JSON_H })
        .catch(function () {})
        .then(function () { window.location.href = url; });
    }, true);

    window.addEventListener('pageshow', function (ev) { if (ev.persisted) reactivar(); });
  }

  /* ---------- Contraentrega (Releasit): sin códigos de tarjeta ---------- */
  function initContraentrega() {
    var permitir = false, trabajando = false;
    document.addEventListener('click', function (e) {
      if (permitir) return;
      var objetivo = e.target && e.target.closest ? e.target.closest('#rsi_buy_now_button') : null;
      if (!objetivo) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (trabajando) return;
      trabajando = true;
      function pasar() { permitir = true; objetivo.click(); permitir = false; trabajando = false; }
      quitarCodigos().then(pasar, pasar);
    }, true);
  }

  function iniciar() {
    var b = boton();
    if (!b) return;
    if (volvioDeTarjeta()) {
      olvidarTarjeta();
      vaciarCarrito().then(function () { window.location.reload(); });
      return;
    }
    quitarCodigos();
    initTarjeta();
    if (b.getAttribute('data-contraentrega') !== 'omitir') initContraentrega();
  }

  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted || !boton()) return;
    if (volvioDeTarjeta()) {
      olvidarTarjeta();
      vaciarCarrito().then(function () { window.location.reload(); });
    } else {
      quitarCodigos();
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
